import React, { Component } from 'react';
import { Container, Popover, Button, TextField, Box, Typography, IconButton } from '@material-ui/core'

import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';


export default class DropInPopover extends Component {

    styles = {
        button: {
            marginLeft: 10,
            marginRight: 10
        },
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 20,
            marginBottom: 10
        }
    };

 
    _okCallback;
    _cancelCallback;
    _maxChars = 1024;

    state = {
        count: 1,
        comment: null
    }
    
    constructor(props) {
        super(props);
        this._okCallback = props.okCallback;
        this._cancelCallback = props.cancelCallback;
    }
   

    _commentFieldChanged = (event) => {
        let val = event.target.value;
        this.setState({commentEntry: val});
    }
    
    _okButtonPressed = () => {        
        this._okCallback(this.state.count, this.state.comment);
        this.setState({count: 1, comment: null});  //clear text for next time
    }
    
    _cancelButtonPressed = () => {
        this._cancelCallback();
        this.setState({count: 1, comment: null});  //clear text for next time
    }
    
    _plusCount = () => {
        if (this.state.count < 100)
            this.setState((prevState) => ({count: prevState.count + 1}));
    }
    
    _minusCount = () => {
        if (this.state.count > 1)
            this.setState((prevState) => ({count: prevState.count - 1}));        
    }
    
    render() {
        
        let maxWidth = window.innerWidth * 0.5;  //half the window, up to 350
        if (maxWidth > 700)
            maxWidth = 700;
         
        return (
            <Popover open={this.props.isOpen} 
                anchorReference="anchorPosition"
                anchorPosition={{left: window.innerWidth/2, top: window.innerHeight/2}}
                transformOrigin={{vertical: 'center', horizontal: 'center'}}  >
                
                <Box style={{margin: 20, width: maxWidth}}>
                    <Typography variant="subtitle1" style={{fontWeight: 'bold'}}>Admit Drop-Ins</Typography>  
                    <div style={{marginTop: 20}}/>

                    <Container style={this.styles.container}>    
                        <IconButton onClick={this._minusCount} style={{marginLeft: 10}}>
                            <IndeterminateCheckBoxIcon style={{ fontSize: 40 }} />
                        </IconButton>                    
                        <TextField label="Admit Count" variant="outlined" value={this.state.count} fullWidth={false} inputProps={{readOnly: true, style: {textAlign: 'center', fontSize: '20px'}  }} InputLabelProps={{ shrink: true}} />
                        <IconButton onClick={this._plusCount} style={{marginRight: 10}}>
                            <AddBoxIcon style={{ fontSize: 40 }}/>
                        </IconButton>  
                    </Container>

                    <TextField label="Admittance Notes" autoFocus multiline={true} rows={5} value={this.state.comment} onChange={(event) => this.setState({comment: event.target.value})} variant="outlined" fullWidth={true} inputProps={{maxLength: this._maxChars}} InputLabelProps={{ shrink: true}} />

                    <Container style={this.styles.container}>    
                        <Button onClick={this._okButtonPressed} color="primary" variant="outlined" style={this.styles.button}>OK</Button>
                        <Button onClick={this._cancelButtonPressed} variant="outlined" style={this.styles.button}>Cancel</Button>
                    </Container>
                </Box>
            </Popover>
        );
        
        
    }


}